import React from 'react';
import { p } from '../i18n/useP';
import './ErrorBoundary.css';

/**
 * Client sans aucun module vendu.
 *
 * Ce n'est pas une panne, c'est un état : le pack `tenants.enabled_modules` est
 * vide, donc il n'y a rien à afficher. Avant, le Cockpit s'ouvrait quand même
 * (c'est une page toujours autorisée), interrogeait des données auxquelles le
 * client n'a pas droit et cassait le rendu — écran vide, sans explication.
 *
 * On dit ce qui manque, et où cela se règle.
 */
export default function NoModulesPage({ tenantName, canManage, onGoSettings }) {
  return (
    <div className="eb">
      <div className="eb__card">
        <div className="eb__label">{p('Aucun module activé')}</div>
        <h2 className="eb__title">
          {tenantName ? `${tenantName} ${p('n’a aucun module activé.')}` : p('Ce client n’a aucun module activé.')}
        </h2>
        <p className="eb__text">
          {p('Les modules définissent ce que ce client peut consulter : People, Finance, Ventes & Opérations, Rentabilité, Planification. Tant qu’aucun n’est activé, il n’y a rien à afficher.')}
        </p>
        <ul className="eb__list">
          <li>{p('Un administrateur active les modules dans Administration › Clients.')}</li>
          <li>{p('Savoirs et Lexique restent accessibles : ils ne dépendent d’aucun module.')}</li>
        </ul>
        {canManage && (
          <div className="eb__actions">
            <button type="button" className="eb__btn eb__btn--main" onClick={onGoSettings}>
              {p('Ouvrir Administration')}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
